import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import _ from 'lodash'
import Leaders from '@app/components/teachers/Leaders'
import Loader from '@app/components/ui/placeholders/Loader'
import * as teacherActions from '@app/actions/teachers'
import { AbilityContext } from '@app/context/ability-context'
import { sortedClasses } from '@app/helpers/classesHelper'

class LeadersContainer extends Component {
  static contextType = AbilityContext;

  constructor(props) {
    super(props)

    this.state = {
      activeClassId: null
    }

    const { dispatch } = props
    this.boundActions = bindActionCreators(teacherActions, dispatch)
    this.handleClassChange = this.handleClassChange.bind(this)
  }

  componentDidMount() {
    this.updateIfNeeded()
  }

  async updateIfNeeded() {
    await this.boundActions.fetchClassesIfNeeded()

    const { classes: { objects } } = this.props
    if (!this.state.activeClassId && objects) {
      const firstClass = _.first(sortedClasses(objects))
      if (firstClass) {
        this.setState({ activeClassId: firstClass.object.id }, () => {
          this.fetchClassData(firstClass.object.id)
        })
      }
    }
  }

  async fetchClassData(classId) {
    const ability = this.context

    if (ability.can('read', 'Statistic', 'main')) {
      await this.boundActions.fetchStatisticsIfNeeded(classId, 'main')

      if (ability.can('read', 'Diplomas')) {
        await this.boundActions.fetchDiplomasIfNeeded(classId, this.props.global.event.id)
      }
    }
  }

  handleClassChange(classId) {
    this.setState({ activeClassId: classId }, () => {
      this.fetchClassData(classId)
    })
  }

  get activeGroup() {
    const { classes: { objects } } = this.props
    const { activeClassId } = this.state

    return objects[activeClassId]
  }

  get olympiad() {
    const group = this.activeGroup
    return group ? _.find(this.props.olympiads, ['grade', group.object.grade]) : null
  }

  render() {
    const {
      classes: { objects, fetching },
      global: { event },
      route
    } = this.props

    const { activeClassId } = this.state

    if (fetching) return <Loader />
    if (_.isEmpty(objects)) return null

    const sortedClassesList = sortedClasses(objects)

    return (
      <Leaders
        classes={sortedClassesList}
        activeClassId={activeClassId}
        group={this.activeGroup}
        olympiad={this.olympiad}
        route={route}
        ability={this.context}
        event={event}
        onClassChange={this.handleClassChange}
      />
    )
  }
}

const mapStateToProps = (state) => {
  const {
    teachers: { classes },
    global: { olympiads }
  } = state;

  return {
    classes,
    olympiads
  }
}

export default connect(
  mapStateToProps,
  null,
  null, {
    getDisplayName: () => 'Leaders'
  }
)(LeadersContainer)